<template>
    <div v-if="rent.statusRental == 2" class="badge-status-invoice" @click="onBadgeClick(itemRent)">
        <div v-if="itemRent.statusInvoiceItemsRent === 1" class="badge-status-invoice-warning">Não Faturado</div>
        <div v-else-if="itemRent.statusInvoiceItemsRent === 2" class="badge-status-invoice-success">Faturado</div>
        <div v-else-if="itemRent.statusInvoiceItemsRent === 3" class="badge-status-invoice-info">Não Fatura</div>
        <div v-else-if="itemRent.statusInvoiceItemsRent === 4" class="badge-status-invoice-danger">Cancelado</div>
        <div v-else-if="itemRent.statusInvoiceItemsRent === 5" class="badge-status-invoice-info">Parcial</div>
        <div v-else class="badge-status-invoice-info">Não Fatura</div>
    </div>
</template>

<script>
export default {
    name: "BadgeStatusInvoice",
    props: {
        rent: { type: Object, required: false },
        itemRent: {
            type: Object,
            default: () => ({
                statusInvoiceItemsRent: 3
            })
        }
    },
    methods: {
        onBadgeClick(payload) {
            console.log("BadgeStatusInvoice clicado:", payload);
        }
    }
};
</script>

<style scoped>
.badge-status-invoice {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    width: 90px;
}

.badge-status-invoice>div {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 8px;
    border-radius: 50px;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    transition: transform 0.12s ease, background-color 0.15s ease;
}

.badge-status-invoice-warning {
    background-color: #e0ac06;
}

.badge-status-invoice-success {
    background-color: #2f855a;
}

.badge-status-invoice-info {
    background-color: #5bbff7;
}

.badge-status-invoice-danger {
    background-color: #b91c1c;
}

.badge-status-invoice-default {
    background-color: #6b7280;
}
</style>
